import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Sacerdote** (manuale V1, rr. 1401-1410).
 *
 * Prete di campagna senza poteri magici reali, ma capace di cura, rimedi e
 * di intercedere con la propria chiesa.
 */
export const sacerdote: FollowerAbility = {
  id: 'sacerdote',
  label: 'Sacerdote',
  description:
    'Un prete di campagna, un frate minore o qualsiasi altra mansione si trovi molto in prossimità del seminterrato. Difetta di poteri magici, ma quando serve sa come ricucirti con ago, filo, un pezzo di legno in bocca e una fiasca di grog. O presentarti alle Alte Sfere. Beh, non esageriamo! Medie?',
  ranks: [
    {
      rank: 1,
      trigger: 'Quando ti *accampi* con un Sacerdote',
      description:
        'Al risveglio tutti guariscono di +1d4 PF. Inoltre, quando *recuperi le forze* e un Sacerdote è con te, rimuovi una Debilitazione a tua scelta ogni due giorni di riposo anziché ogni tre.',
    },
    {
      rank: 2,
      trigger: 'Quando un Sacerdote ha il tempo necessario per ricucirti le ferite',
      description:
        'Recuperi 1d8 PF. Il Sacerdote non può guarirti di nuovo finché non subisci altri danni.',
    },
    {
      rank: 3,
      trigger: 'Quando un Sacerdote intercede per te con la sua chiesa',
      description:
        'Una tua richiesta ragionevole e tematicamente appropriata (a discrezione del GM) verrà esaudita. Il Sacerdote può usare questa mossa una sola volta per sessione.',
    },
  ],
};
